import {API_URL, apiDelete} from '../api'
import {ApiRes} from '../../types/api'

/**
 * DELETE /v3/admin/volume-league/:id — 리그 + 라이브 보드 삭제
 */
export const deleteVolumeLeague = async (id: number | string): Promise<ApiRes<any>> => {
    return await apiDelete(API_URL, `admin/volume-league/${id}`)
}
